import { ActivityStepData, ContainActivityStep } from '../pairs/ActivityStep/Container';
import { ContainContentAudio } from './ContentAudio/ContainContentAudio';
import { ContainContentText } from './ContentText/ContainContentText';
import { ContainExercise, ExerciseData } from './Exercise/ContainExercise';
import { ContainRadar, RadarData } from './Radar/ContainRadar';
import { ContainSurveyResult } from './SurveyResult/ContainSurveyResult';
import { ContentAudioData, PresentContentAudio } from './ContentAudio/PresentContentAudio';
import { ContentTextData } from './ContentText/ContainContentText';
import { FC, ReactElement } from 'react';
import { PresentActivityStep } from '../pairs/ActivityStep/presenters/PresentActivityStep';
import { PresentContentText } from './ContentText/PresentContentText';
import { PresentExercise } from './Exercise/PresentExercise';
import { PresentRadar } from './Radar/PresentRadar';
import { PresentSurveyResult, SurveyResultData } from './SurveyResult/PresentSurveyResult';
import { PresentFrame } from './Frame/PresentFrame';
import { QuestionSession } from '../QuestionSessions/QuestionSession/QuestionSession';

export interface SessionContainerProps<T extends Record<string, unknown>  = Record<string, unknown>> {
  onNext: () => void;
  onFinish: () => void;
  children: (presentationState: SessionPresentationProps<T>) => ReactElement
}

export interface SessionPresentationProps<T extends Record<string, unknown> = Record<string, unknown>> {
  onNext?: () => void;
  onFinish?: () => void;
  data: T,
  labels?: Record<string, string>,
}

interface SessionConfig<T extends Record<string, unknown> = Record<string, unknown>> {
  Container?: FC<SessionContainerProps<T>>;
  Presentation?: FC<SessionPresentationProps<T>>;
}


type ConfigType = {
  FRAME: SessionConfig;
  QUESTION: SessionConfig;
  CONTENT_AUDIO: SessionConfig<ContentAudioData>;
  CONTENT_TEXT: SessionConfig<ContentTextData>;
  EXERCISE: SessionConfig<ExerciseData>;
  ACTIVITY: SessionConfig<ActivityStepData>;
  FEATURE: SessionConfig<SurveyResultData>;
  RADAR: SessionConfig<RadarData>;
};

export const config: ConfigType = {
  FRAME: {
    Presentation: PresentFrame
  },
  QUESTION: {
    Presentation: QuestionSession,
  },
  CONTENT_AUDIO: {
    Container: ContainContentAudio,
    Presentation: PresentContentAudio,
  },
  CONTENT_TEXT: {
    Container: ContainContentText,
    Presentation: PresentContentText,
  },
  EXERCISE: {
    Container: ContainExercise,
    Presentation: PresentExercise,
  },
  ACTIVITY: {
    Container: ContainActivityStep,
    Presentation: PresentActivityStep,
  },
  FEATURE: {
    Container: ContainSurveyResult,
    Presentation: PresentSurveyResult,
  },
  RADAR: {
    Container: ContainRadar,
    Presentation: PresentRadar,
  }
};
